<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.storeName"
              placeholder="请输入店名"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
        @dblclick="viewFun(arguments)"
        @view="viewFun(arguments)"
      />
    </div>
    <!-- 查看 -->
    <store-view-dialog
      :data-id="id"
      :dialog-title="'查看零售户档案'"
      :dialog-visible.sync="dialogStoreViewVisible"
    />
    <!-- 查看 -->
    <special-store-view-dialog
      :data-id="id"
      :dialog-title="'查看特殊终端'"
      :dialog-visible.sync="dialogSpecialStoreViewVisible"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 查看
import storeViewDialog from '@/views/terminalModule/storeArchives/components/viewDialog'
// 查看
import specialStoreViewDialog from '@/views/terminalModule/storeArchives/components/viewDialog'
// 数据请求
import { loadStoreVisitReportStatisticsListDataApi, loadStoreVisitReportStatisticsExportDataApi } from '@/api/storeVisitReport'
export default {
  name: 'StoreVisitReportStatistics',
  components: {
    CustomTable,
    TableOperation,
    storeViewDialog,
    specialStoreViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'store_visit_materials_detail_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['special_store_info_view', 'store_info_view'],
            prop: 'view',
            label: '查看终端',
            method: 'view'
          },
          {
            permissionSigns: ['store_visit_report_statistics_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: 'db.year_amount', // 排序字段
            order: 'desc' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            storeName: '',
            certificateNo: ''
          }
        }
      },
      id: null, // 选中的单据ID
      dialogStoreViewVisible: false, // 零售户档案查看
      dialogSpecialStoreViewVisible: false // 特殊终端查看
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'db.province_name', width: 100 },
      { prop: 'cityName', label: '城市', filterColumn: 'db.city_name', width: 100 },
      { prop: 'countyName', label: '区县', filterColumn: 'db.county_name', width: 100 },
      { prop: 'storeName', label: '店名', filterColumn: 'db.store_name', width: 150 },
      { prop: 'certificateNo', label: '专卖证号', filterColumn: 'db.certificate_no', width: 120 },
      { prop: 'address', label: '地址', filterColumn: 'db.address', width: 180 },
      { prop: 'realStoreName', label: '真实店名', filterColumn: 'db.real_store_name', width: 150 },
      { prop: 'realAddress', label: '真实地址', filterColumn: 'db.real_address', width: 150 },
      { prop: 'billTypeStr', label: '终端类型', filterColumn: '(case db.bill_type when 1 then "零售户" when 2 then "特殊终端" else "" end)', width: 120 },
      { prop: 'storeSortStr', label: '零售户类型', filterColumn: '(case db.store_sort when 1 then "重点终端" when 2 then "" when 3 then "潜力终端" when 4 then "信息采集终端" else "" end)', width: 120 },
      { prop: 'visitLine', label: '拜访线路', filterColumn: 'db.visit_line', width: 120 },
      { prop: 'visitFrequencyStr', label: '拜访频次', filterColumn: '(case db.visit_frequency when 1 then \'1周1次\' when 2 then \'2周1次\' when 3 then \'1月1次\' when 4 then \'2月1次\' when 5 then \'3月1次\' when 6 then \'1周2次\' else \'\' end)', width: 120 },
      { prop: 'visitPlanStr', label: '拜访计划', filterColumn: '(case db.visit_plan when 1 then \'周一\' when 2 then \'周二\' when 3 then \'周三\' when 4 then \'周四\' when 5 then \'周五\' when 6 then \'周六\' when 7 then \'周日\' else \'\' end)', width: 120 },
      { prop: 'statusStr', label: '状态', filterColumn: '(case db.status when 1 then "维护中" when 2 then "停止维护" else "" end)', width: 80 },
      { prop: 'manageUserName', label: '维护人', filterColumn: 'db.manage_user_name', width: 120 },
      { prop: 'yearAmount', label: '本年拜访次数', filterColumn: 'db.year_amount', width: 130, isBetween: true },
      { prop: 'quarterAmount', label: '本季拜访次数', filterColumn: 'db.quarter_amount', width: 130, isBetween: true },
      { prop: 'monthAmount', label: '本月拜访次数', filterColumn: 'db.month_amount', width: 130, isBetween: true },
      { prop: 'lastMonthAmount', label: '上月拜访次数', filterColumn: 'db.last_month_amount', width: 130, isBetween: true },
      { prop: 'visitDateStr', label: '最近拜访日期', filterColumn: 'db1.visit_date', width: 130, isBetween: true },
      { prop: 'yunDisplayStatusStr', label: '陈列保持', filterColumn: '(case db1.yun_display_status when 1 then "有陈列" when 0 then "无陈列" else "" end)', width: 120 },
      { prop: 'displayGridStr', label: '陈列格数', filterColumn: '(case db1.display_grid when 1 then "小于1格(背柜)" when 2 then "1格(背柜)" when 3 then "2格(背柜)" when 4 then "3格(背柜)" when 5 then "大于3格(背柜)" else "" end)', width: 140 },
      { prop: 'displayCount', label: '本年陈列保持次数', filterColumn: 'db4.display_count', width: 150 },
      { prop: 'noDisplayReasonStr', label: '无陈列原因', filterColumn: '(case db1.no_display_reason when 1 then "店主不配合" when 2 then "店内无陈列空间" when 3 then "由于工商及商业等政策影响导致无法陈列" when 4 then "陈列空间被竞争对手占据" when 5 then "其它" when 6 then "无陈列烟模" when 7 then "关门未营业" else "" end)', width: 150 },
      { prop: 'noDisplayExplanation', label: '无陈列说明', filterColumn: 'db1.no_display_explanation', width: 150 },
      { prop: 'total', label: '礼品投放总价值', filterColumn: 'ifnull(db2.total, 0)', width: 140, isBetween: true },
      { prop: 'total3', label: '样品烟投放总价值', filterColumn: 'ifnull(db3.total, 0)', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadStoreVisitReportStatisticsListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 查询
    searchData () {
      // 重置右键筛选条件
      this.masterList.tableQuery.page = 1
      this.masterList.tableQuery.contextmenuWrap = []
      // 重置排序条件
      this.masterList.tableQuery.sort.prop = 'db.year_amount'
      this.masterList.tableQuery.sort.order = 'desc'
      this.loadTableData()
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].storeId
      if (Number(args[0].billType) === 2) {
        this.dialogSpecialStoreViewVisible = !this.dialogSpecialStoreViewVisible
      } else {
        this.dialogStoreViewVisible = !this.dialogStoreViewVisible
      }
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadStoreVisitReportStatisticsExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
